<dx-data-grid [dataSource]="organisations"
              [allowColumnReordering]="true"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [rowAlternationEnabled]="true">
    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
    <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>

    <dxi-data-grid-column dataField="organisationId"
                          caption="Id"
                          width="80"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="name"
                          caption="Name"
                          cellTemplate="organisationCellTemplate"></dxi-data-grid-column>
    <dxi-data-grid-column caption="Lumia"
                          dataField="urlIdentifier"
                          cellTemplate="lumiaCellTemplate"></dxi-data-grid-column>

    <div *dxTemplate="let data of 'organisationCellTemplate'">
        <adapt-link-organisation [organisation]="data.data"></adapt-link-organisation>
    </div>

    <div *dxTemplate="let data of 'lumiaCellTemplate'">
        <adapt-link-organisation-embed [organisation]="data.data"></adapt-link-organisation-embed>
    </div>
</dx-data-grid>
